import {
  getDateRangeBySignalDatePreset2x,
  getSelectedPeriodDateRange1x,
} from '@/features/(signal)/signals/lib';
import type { SignalDateSelectionInput } from '@/features/(signal)/signals/model';

type ResolveIssueDetailDateRangeParams = {
  datePreset: SignalDateSelectionInput;
  mode: 'composited' | 'selected';
};

export const resolveIssueDetailDateRange = (
  params: ResolveIssueDetailDateRangeParams,
) => {
  if (params.mode === 'selected') {
    return getSelectedPeriodDateRange1x(params.datePreset);
  }

  return getDateRangeBySignalDatePreset2x(params.datePreset);
};
